<template>
    <div id="ams-login" class="apply-bootstrap">
        <div class="container">
            <div class="row" id="ams-login-form">
                <div id="amsLogo">
                    <img alt="AMS Login Page" src="../../ams/xsl/images/amsLogo.png">
                </div>
                <div class="ams-login-centered">
                    <h1>Account Management System</h1>
                    <layout-container c-id="layoutContainer_AMS_Login"></layout-container>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import "@common/syncfusionCss";
import { library } from "@common/library/library";
import { uStore } from "@common/userStore";

const amsLoginCmp = {
    components: {
        layoutContainer: defineAsyncComponent(() => import('@common/layoutContainer/layoutContainer.vue')),
        loginForm: defineAsyncComponent(() => import('@common/loginForm/loginForm.vue'))
    },
    methods: {
        processAction: async function (act) {
            switch (act) {
                case 'login':
                    if (library.isFromLocalhost()) {
                        let localSid = library.getCookie('sds_localSid');
                        let loggedUser = await uStore().getLoggedUsers(['ams']);
                        if (localSid) {
                            location.href = PROJECTS_URL + 'ams/index.php?localhostDIS=' + localSid + '&localhostClientID=' + loggedUser;
                            return;
                        }
                        uStore().logout('ams');
                        return;
                    }
                    location.href = '../ams/index.php';
                    location.reload();
                    break;
            }
        },
    }
};

export default amsLoginCmp;
</script>

<style lang="css">

body {
    background-color:#FFFFFF;
    margin:0
}

.ams-login-centered {
    text-align: center;
}

#ams-login h1 {
    color:#005C8F;
    font-family:Arial;
    font-size:16pt;
    font-weight: bold;
}

#amsLogo {
    width: 100%;
    margin-left: -30px;
}

#ams-login #LoginPanel {
    background-color: #FFFFFF !important;
    border-width: 0px !important;
    padding-top: 0px !important;
}

#ams-login .sso-client {
    background-color: #FFFFFF !important;
    border-width: 0px !important;
}

#ams-login label {
    font-size: 14px !important;
    color: #888888;
    font-weight: 500;
}

#ams-login button, #ams-login input, #ams-login select, #ams-login textarea {
    background-color: transparent;
    border-style: none;
}

#ams-login .e-control-wrapper {
    border-bottom-width: 1px;
    border-bottom-color: #D4D4D4;
}

#ams-login .e-input {
    border-bottom-width: 0px;
    padding: 3px 5px;
}

#ams-login .privacy-policy {
    font-size: 7pt;
    font-weight: bold;
    padding-top: 20px;
}

#ams-login .require-indicator {
    display: none;
}

#ams-login .login-form-login {
    padding-top: 20px;
}

#ams-login .login-form-login > div {
    display: inline !important;
    justify-content: center !important;
}

#ams-login button {
    color: #FFF !important;
    background: #005C8F !important;
    width: 100%;
    font-size: 14px;
    text-transform: capitalize;
}

#ams-login #GooglePanel {
    background-color: #FFFFFF;
    border-bottom-color: #D4D4D4;
    border-width: 1px 0px 1px 0px;
    border-bottom-style: solid;
    padding: 20px 0px 20px 0px;
    margin-top: -20px;
    margin-left: 20px;
    margin-right: 20px;
}

#ams-login .custom-message-container {
    width: 100%;
}

#ams-login-form {
    width: 350px;
    max-width: 90%;
    margin: 0 auto;
}

</style>
